<template>
  <table class="table table-bordered">
    <tr class="title p-1 w-full">
      <th colspan="3">DADOS BANCÁRIOS PARA RESTITUIÇÃO</th>
    </tr>
    <tr>
      <td v-if="refundValueToDisplay" class="pl-3">
        <b>Valor a restituir:</b> {{ refundValueToDisplay }}
      </td>
      <td class="pl-3" :colspan="refundValueToDisplay ? 2 : 3">
        <b>Forma de restituição:</b> {{ payoutMethodLabel }}
      </td>
    </tr>
    <tr v-if="hasBankAccountPayout">
      <td class="pl-3"><b>Instituição Financeira:</b> {{ bankLabel }}</td>
      <td class="pl-3"><b>Agência:</b> {{ refundData.agency || '-' }}</td>
      <td class="pl-3">
        <b>Conta Corrente:</b>
        {{ formatBankAccount(refundData.account, refundData.accountDigit) }}
      </td>
    </tr>
    <tr v-if="hasPixPayout">
      <td class="pl-3"><b>Chave Pix:</b> {{ refundData.pixKey || '-' }}</td>
      <td class="pl-3" colspan="2"></td>
    </tr>
    <tr>
      <td class="pl-3">
        <b>CPF/CNPJ do Titular:</b> {{ refundData.holderDocument || '-' }}
      </td>
      <td class="pl-3" colspan="2">
        <b>Nome do Titular:</b> {{ refundData.holderName || '-' }}
      </td>
    </tr>
  </table>
</template>

<script>
import {
  formatCurrencyBRL,
  getAvailableRefundPayoutMethods,
  REFUND_METHOD_LABELS,
  REFUND_PAYOUT_METHODS,
} from '../../../views/pages/Endorsement/utils/refundCompensation';

export default {
  name: 'EndorsementRefundPayoutDetails',
  props: {
    refundData: {
      type: Object,
      default: () => ({}),
    },
    refundBankOptions: {
      type: Array,
      default: () => [],
    },
    refundComposition: {
      type: Object,
      default: null,
    },
  },
  computed: {
    payoutMethods() {
      return getAvailableRefundPayoutMethods(this.refundData);
    },
    hasPixPayout() {
      return this.payoutMethods.includes(REFUND_PAYOUT_METHODS.PIX);
    },
    hasBankAccountPayout() {
      return this.payoutMethods.includes(REFUND_PAYOUT_METHODS.BANK_ACCOUNT);
    },
    payoutMethodLabel() {
      if (this.hasPixPayout && this.hasBankAccountPayout) {
        return REFUND_METHOD_LABELS.BANK_TRANSFER;
      }

      if (this.hasPixPayout) {
        return REFUND_METHOD_LABELS.PIX;
      }

      return REFUND_METHOD_LABELS.BANK_ACCOUNT;
    },
    refundValueToDisplay() {
      if (!this.refundComposition || !this.refundComposition.hasBankTransfer) {
        return null;
      }

      return formatCurrencyBRL(this.refundComposition.bankTransferValue);
    },
    bankLabel() {
      if (!this.refundData.bankId) {
        return '-';
      }

      const bank = this.refundBankOptions.find(
        (option) => option.id === this.refundData.bankId,
      );

      return bank ? bank.label : this.refundData.bankId;
    },
  },
  methods: {
    formatBankAccount(account, accountDigit) {
      if (!account && !accountDigit) {
        return '-';
      }

      if (!accountDigit) {
        return account;
      }

      return `${account}-${accountDigit}`;
    },
  },
};
</script>
